var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRssIcon = function SvgRssIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2890A",
    d: "M45 1H5C2.8 1 1 2.8 1 5v40c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V5c0-2.2-1.8-4-4-4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 34.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4.3c12 0 21.7 9.7 21.7 21.7H38c0-14.4-11.6-26-26-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.7V25c7.2 0 13 5.8 13 13h4.3c0-9.6-7.7-17.3-17.3-17.3"
  }))));
};
export default SvgRssIcon;